import IndiaWithdraw from '@/views/withdraw/IndiaWithdraw'
import UnionPayWithdrawCps from '@/views/withdraw/UnionpayWithdrawCps'
import CreditCardWithdraw from '@/views/withdraw/CreditCardWithdraw'
import NetellerWithdraw from '@/views/withdraw/NetellerWithdraw'
import SkrillWithdraw from '@/views/withdraw/SkrillWithdraw'
import BitcoinWithdraw from '@/views/withdraw/BitcoinWithdraw'
import LaosWithdraw from '@/views/withdraw/LaosWithdraw'
import DasshpeWithdraw from '@/views/withdraw/DasshpeWithdraw'
import BankTransfer from '@/views/withdraw/BankTransfer'
import UsdtWithdraw from '@/views/withdraw/UsdtWithdraw'
import PerfectMoneyWithdraw from '@/views/withdraw/PerfectMoneyWithdraw'
import LocalDepositorWithdraw from '@/views/withdraw/LocalDepositorWithdraw'
import JapanWithdraw from '@/views/withdraw/JapanWithdraw'
import FPXWithdraw from '@/views/withdraw/FPXWithdraw'
import NigeriaWithdrawVue from '@/views/withdraw/NigeriaWithdraw.vue'
import BitwalletWithdraw from '@/views/withdraw/BitwalletWithdraw.vue'
import EthWithdraw from '@/views/withdraw/EthWithdraw.vue'
import UsdcWithdraw from '@/views/withdraw/UsdcWithdraw.vue'
import CpsWithdraw from '@/views/withdraw/CpsWithdraw.vue'
import InteracGigadatWithdraw from '@/views/withdraw/InteracGigadatWithdraw.vue'

export default {
  data() {
    return {
      // id对照表 https://hytechconsult-my.sharepoint.com/:x:/g/personal/weiyang_chua_hytechc_com/EcUQdNDIvXVAltd1O0shsrYB_eTpqiMCfGpZHSNeU25unA?wdOrigin=TEAMS-MAGLEV.p2p_ns.rwc&wdExp=TEAMS-TREATMENT&wdhostclicktime=1710470888710&web=1
      withdrawalTypesMap: {
        1: {
          component: CreditCardWithdraw,
          img: require('@/assets/images/withdraw/credit_img.jpg'),
        },
        2: {
          component: BankTransfer,
          img: require('@/assets/images/channel/swift.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b37BDays') },
          note: [
            this.$t('withdraw.default.ibtInfo1'),
            this.$t('withdraw.default.ibtInfo2'),
            this.$t('withdraw.default.ibtInfo3'),
          ],
        },
        4: {
          component: UnionPayWithdrawCps,
          // img: require('@/assets/images/withdraw/select_unionpay.png'),
          img: require('@/assets/images/channel/unionpay.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
          note: [this.$t('withdraw.default.unionpayInfo')],
        },
        5: {
          component: CpsWithdraw, // Thailand IBT
          img: require('@/assets/images/withdraw/select_thailand.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        6: {
          component: CpsWithdraw, // Malaysia IBT
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        7: {
          component: CpsWithdraw, // Fasapay
          img: require('@/assets/images/channel/fasapay.png'),
          // img: require('@/assets/images/withdraw/select_fasapay.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
          note: [this.$t('withdraw.default.fasapayInfo1'), this.$t('withdraw.default.fasapayInfo2')],
        },
        8: {
          component: CpsWithdraw, // Vietnam
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        24: {
          component: IndiaWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
          note: [this.$t('withdraw.default.banktransferInfo')],
        },
        31: {
          component: SkrillWithdraw,
          img: require('@/assets/images/channel/skrill.png'),
          // img: require('@/assets/images/withdraw/select_skill.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
          note: [this.$t('withdraw.default.skrillInfo2'), this.$t('withdraw.default.eeaCountriesInfo')],
        },
        32: {
          component: NetellerWithdraw,
          img: require('@/assets/images/channel/neteller.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
          note: [this.$t('withdraw.default.netellerInfo2'), this.$t('withdraw.default.eeaCountriesInfo')],
        },
        34: {
          component: BitcoinWithdraw,
          img: require('@/assets/images/channel/deposit_bitcoin.png'),
          // img: require('@/assets/images/withdraw/select_bitcoin.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
          note: [
            this.$t('withdraw.default.cryptoInfo1'),
            this.$t('withdraw.default.cryptoInfo2'),
            this.$t('withdraw.default.cryptoInfo3'),
          ],
        },
        35: {
          component: CpsWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/channel/local_transfer-50x50.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        36: {
          component: UsdtWithdraw,
          img: require('@/assets/images/channel/deposit_usdt.png'),
          // img: require('@/assets/images/withdraw/select_usdt.png'),
          time: { withdraw: this.$t('processTime.instant') },
          note: [
            this.$t('withdraw.default.cryptoInfo1'),
            this.$t('withdraw.default.cryptoInfo2'),
            this.$t('withdraw.default.cryptoInfo3'),
          ],
        },
        37: {
          component: BitwalletWithdraw,
          img: require('@/assets/images/channel/bitwallet.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
          note: [this.$t('withdraw.default.bitwalletInfo')],
        },
        39: {
          component: CpsWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        40: {
          component: CpsWithdraw, //Philipines
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
          note: [this.$t('withdraw.default.banktransferInfo')],
        },
        42: {
          component: CpsWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/channel/local_transfer-50x50.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
          note: [this.$t('withdraw.default.banktransferInfo')],
        },
        47: {
          component: LaosWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_bank.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        48: {
          component: DasshpeWithdraw,
          img: require('@/assets/images/withdraw/select_upi.png'),
        },
        49: {
          component: CpsWithdraw, // Hong Kong Local Bank Transfer
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        61: {
          component: PerfectMoneyWithdraw,
          img: require('@/assets/images/channel/deposit_PerfectMoney.png'),
          // img: require('@/assets/images/withdraw/select_PerfectMoney.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
          note: [this.$t('withdraw.default.perfectmoneyInfo1'), this.$t('withdraw.default.perfectmoneyInfo2')],
        },
        62: {
          component: JapanWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_vietna.png'),
          time: { withdraw: this.$t('processTime.within1BDay'), bank: this.$t('processTime.b13BDays') },
        },
        63: {
          component: CpsWithdraw, // Mexico IBT
          // img: require('@/assets/images/withdraw/select_bank.png'),
          img: require('@/assets/images/channel/deposit_bank.png'),
        },
        64: {
          component: CpsWithdraw, // Brazil IBT
          // img: require('@/assets/images/withdraw/select_bank.png'),
          img: require('@/assets/images/channel/deposit_bank.png'),
        },
        65: {
          component: CpsWithdraw, // Local Depositor
          // img: require('@/assets/images/channel/deposit_bank.png'),
          img: require('@/assets/images/channel/deposit_LocalDepositor.png'),
        },
        66: {
          //FPX
          component: FPXWithdraw,
          img: require('@/assets/images/channel/FPX.png'),
          // img: require('@/assets/images/channel/vietna.png'),
        },
        67: {
          component: NigeriaWithdrawVue,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_nigeria.png'),
        },
        75: {
          component: CpsWithdraw,
          img: require('@/assets/images/channel/ebuy-logo.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
        },
        80: {
          component: EthWithdraw,
          img: require('@/assets/images/channel/ethereum.png'),
          time: { withdraw: this.$t('processTime.instant') },
          note: [
            this.$t('withdraw.default.cryptoInfo1'),
            this.$t('withdraw.default.cryptoInfo2'),
            this.$t('withdraw.default.cryptoInfo3'),
          ],
        },
        81: {
          component: UsdcWithdraw,
          img: require('@/assets/images/channel/usdc-logo.png'),
          time: { withdraw: this.$t('processTime.instant') },
          note: [
            this.$t('withdraw.default.cryptoInfo1'),
            this.$t('withdraw.default.cryptoInfo2'),
            this.$t('withdraw.default.cryptoInfo3'),
          ],
        },
        86: {
          component: CpsWithdraw, // USDTTRC20
          img: require('@/assets/images/channel/deposit_usdt.png'),
        },
        87: {
          component: CpsWithdraw, // USDTERC20
          img: require('@/assets/images/channel/deposit_usdt.png'),
        },
        88: {
          component: CpsWithdraw, // Chile IBT
          // img: require('@/assets/images/withdraw/select_bank.png'),
          img: require('@/assets/images/channel/deposit_bank.png'),
        },
        89: {
          component: CpsWithdraw, // Columbia IBT
          // img: require('@/assets/images/withdraw/select_bank.png'),
          img: require('@/assets/images/channel/deposit_bank.png'),
        },
        97: {
          component: CpsWithdraw, // FX-IR (Iran)
          img: require('@/assets/images/withdraw/fx-ir.png'),
          time: { withdraw: this.$t('processTime.within2BDay') },
        },
        99: {
          component: InteracGigadatWithdraw,
          img: require('@/assets/images/channel/interac.png'),
          time: { withdraw: this.$t('processTime.within1BDay') },
        },
        100: {
          // PIX
          component: CpsWithdraw,
          img: require('@/assets/images/channel/PIX.png'),
          // img: require('@/assets/images/withdraw/select_bank.png'),
        },
        106: {
          // Cryptocurrency-USDT-BEP
          component: CpsWithdraw,
          img: require('@/assets/images/channel/deposit_usdt.png'),
        },
        108: {
          // UAE Bank Transfer
          component: CpsWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
        },
        109: {
          // AirTM
          component: CpsWithdraw,
          img: require('@/assets/images/channel/airtm.png'),
        },
        110: {
          //noda payment
          component: CpsWithdraw,
          img: require('@/assets/images/channel/deposit_bank.png'),
          // img: require('@/assets/images/withdraw/select_bank.png'),
        },
        115: {
          //Bkash
          component: CpsWithdraw,
          time: { withdraw: this.$t('processTime.instant') },
          img: require('@/assets/images/channel/Bkash.png'),
        },
        117: {
          // Nagad
          component: CpsWithdraw,
          time: { withdraw: this.$t('processTime.instant') },
          img: require('@/assets/images/channel/nagad.png'),
        },
        118: {
          //Rocket
          component: CpsWithdraw,
          time: { withdraw: this.$t('processTime.instant') },
          img: require('@/assets/images/channel/ecpay-rocket.png'),
        },
        122: {
          //TCPay
          component: CpsWithdraw,
          time: { withdraw: this.$t('processTime.instant') },
          img: require('@/assets/images/channel/TCPay.png'),
        },
      },
    }
  },
}
